export default "__VITE_ASSET__DFxMbXmM__"